import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, useApi, fmtDate } from "../../lib/api";
import { useAuth, hasRole } from "../../context/AuthContext";
import { SampleBadge } from "../Badges";

const ST = { pending: "pill-amber", approved: "pill-green", rejected: "pill-red" };

export const Leave = () => {
  const { user } = useAuth();
  const mgr = hasRole(user, ["manager", "hr", "gm", "executive"]);
  const { data, reload } = useApi("/leave");
  const { data: pay } = useApi("/payslips");
  const [f, setF] = useState({ start: "", end: "", type: "annual", reason: "" });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/leave", f);
      toast.success("Leave request sent to your manager");
      setF({ start: "", end: "", type: "annual", reason: "" });
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const decide = async (id, status) => {
    try {
      await api.patch(`/leave/${id}`, { status });
      toast.success(`Leave ${status}`);
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div className="grid lg:grid-cols-3 gap-6" data-testid="hr-self-service">
      <div className="space-y-6">
        <form onSubmit={submit} className="panel p-5 grid gap-3" data-testid="leave-form">
          <div className="eyebrow">Request leave</div>
          <div className="grid grid-cols-2 gap-3">
            <input required type="date" className="field" value={f.start} onChange={set("start")} data-testid="leave-start-input" />
            <input required type="date" className="field" value={f.end} onChange={set("end")} data-testid="leave-end-input" />
          </div>
          <select className="field" value={f.type} onChange={set("type")} data-testid="leave-type-select">{["annual", "sick", "maternity", "paternity", "compassionate", "study"].map((t) => <option key={t}>{t}</option>)}</select>
          <input className="field" placeholder="Reason (optional)" value={f.reason} onChange={set("reason")} data-testid="leave-reason-input" />
          <button className="btn-gold" data-testid="leave-submit-btn">Submit request</button>
        </form>
        <div className="panel p-5" data-testid="payslip-panel">
          <div className="eyebrow mb-2">Payslips</div>
          <p className="text-sm text-slate-400">{pay?.message}</p>
          <div className="mt-2"><SampleBadge label="Payroll not connected" /></div>
        </div>
      </div>
      <div className="lg:col-span-2 panel p-5">
        <div className="eyebrow mb-4">{mgr ? "Team leave requests" : "My leave requests"}</div>
        <div className="divide-y divide-[color:var(--line)]">
          {(data || []).map((l) => (
            <div key={l.id} className="py-3 flex flex-wrap items-center justify-between gap-3" data-testid={`leave-row-${l.id}`}>
              <div>
                <div className="text-sm text-ink">{l.name} <span className="text-slate-500">· {l.type}</span></div>
                <div className="font-data text-[11px] text-slate-400">{l.start} → {l.end} · requested {fmtDate(l.created_at)}</div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`pill ${ST[l.status]}`}>{l.status}</span>
                {mgr && l.status === "pending" && (
                  <>
                    <button onClick={() => decide(l.id, "approved")} className="text-xs text-green-400 hover:underline" data-testid={`leave-approve-${l.id}`}>Approve</button>
                    <button onClick={() => decide(l.id, "rejected")} className="text-xs text-red-400 hover:underline" data-testid={`leave-reject-${l.id}`}>Reject</button>
                  </>
                )}
              </div>
            </div>
          ))}
          {data?.length === 0 && <div className="text-sm text-slate-500 py-4">No leave requests yet.</div>}
        </div>
      </div>
    </div>
  );
};
